module.exports = __webpack_public_path__ + "static/naples-2018-0c3e2b5dc743fabe45527ae7ce7ff4c6.jpg";